import { Location } from '@agroone/entities'
import { FeatureCollection, SaveFeatureCollection } from '@agroone/entities'

export class PointOfInterest {
  public id: number | null | undefined
  public location: Location
  constructor(id: number | null | undefined, location: Location) {
    this.id = id
    this.location = location
  }
}

export class BoundaryOfInterest {
  public id: number | null | undefined
  public boundary: FeatureCollection | SaveFeatureCollection | null | undefined
  constructor(id: number | null | undefined, boundary: FeatureCollection | SaveFeatureCollection | null | undefined) {
    this.id = id
    this.boundary = boundary
  }
}

export interface Feature {
  points: PointOfInterest[]
  boundaries: BoundaryOfInterest[]
}
